import { BidsRepository } from '@/core/repositories/bids.repository'
import {
    BidsGetBidsParamsT,
    BidsGetBidsResponseT,
    BidsGetBidsOnSignParamsT,
    BidsGetBidsOnSignResponseT,
    BidsGetBidResponseT,
    BidsGetBidStatusesResponse,
    BidsGetFtlExcelParams,
    BidsEditSignersPayload,
    GetBidByIdDovogor24Response,
} from '../types/bids.types'

const bidsRepository = new BidsRepository()

export class BidsService {
    async resendToContract(id: number): Promise<void> {
        await bidsRepository.resendToContract(id)
    }

    async resendToContractFtl(id: number): Promise<void> {
        await bidsRepository.resendToContractFtl(id)
    }

    async getBid(id: number): Promise<BidsGetBidResponseT> {
        const response = await bidsRepository.getBid(id)
        return response.data
    }

    async getBidNew(id: number): Promise<BidsGetBidResponseT> {
        const response = await bidsRepository.getBidNew(id)
        return response.data
    }

    async getBids(params: BidsGetBidsParamsT): Promise<BidsGetBidsResponseT> {
        const response = await bidsRepository.getBids(params)
        return response.data
    }

    async getLogistBidStatuses(): Promise<BidsGetBidStatusesResponse> {
        const response = await bidsRepository.getLogistBidStatuses()
        return response.data
    }

    async getTmsBids(params: BidsGetBidsParamsT): Promise<BidsGetBidsResponseT> {
        const response = await bidsRepository.getTmsBids(params)
        return response.data
    }

    async getDogovor24ById(bidId: number): Promise<GetBidByIdDovogor24Response> {
        const response = await bidsRepository.getDogovor24ById(bidId)
        return response.data
    }

    async getBidsOnSign(params: BidsGetBidsOnSignParamsT): Promise<BidsGetBidsOnSignResponseT> {
        const response = await bidsRepository.getBidsOnSign(params)
        return response.data
    }

    async createBidFtl(id: number, payload: FormData): Promise<void> {
        await bidsRepository.createBidFtl(id, payload)
    }

    async createBid(payload: FormData): Promise<void> {
        await bidsRepository.createBid(payload)
    }

    async deleteBid(id: number): Promise<void> {
        const response = await bidsRepository.deleteBid(id)
        return response.data
    }

    async deleteTmsBid(id: number): Promise<void> {
        const response = await bidsRepository.deleteTmsBid(id)
        return response.data
    }

    async downloadContract(bid_id: number): Promise<any> {
        const response = await bidsRepository.downloadContract(bid_id)
        return response.data
    }

    async editSigners(id: number, payload: BidsEditSignersPayload): Promise<any> {
        const response = await bidsRepository.editSigners(id, payload)
        return response.data
    }

    async downloadFtlBidsExcel(params: BidsGetFtlExcelParams): Promise<any> {
        const response = await bidsRepository.downloadFtlBidsExcel(params)
        return response.data
    }
}
